<template>
  <div class="wb-overlay-screen" @click="isVisibleModal" >
    <div class="wb-overlay-screen-container" v-on:click.stop>
      <SVGClose @click="isVisibleModal" class="wb-overlay-screen-close"/>
      <h2 class="wb-overlay-screen-text">Сделать снимок</h2>
      <img class="wb-overlay-screen-img" :src="screenIMG" alt="ScreenShot">
      <button
          @click="downloadScreenshot"
          class="wb-overlay-screen-button"
      >СОХРАНИТЬ ФОТО</button>
    </div>
  </div>
</template>

<script>
import NavbarGreenButton from '@/UI/Components/ComponentsNavbar/NavbarGreenButton.vue';
import SVGClose from '@/UI/Components/SVG/SVGClose.vue';
import { downloadScreenshot, takeScreenshot } from '@/lib/takeScreenshot';

export default {
  name: 'OverlayScreen',
  components: { SVGClose, NavbarGreenButton },
  props: [
      'top',
      'left',
  ],
  data() {
    return {
      screenIMG: '',
    };
  },
  mounted() {
    this.screenIMG = window.screen__img;
  },
  methods: {
    downloadScreenshot,
    isVisibleModal() {
      this.$emit('is-visible-modal');
    },
    takeScreenshot,
  },
};
</script>

<style lang="scss" scoped>
@import "CSS/colors.scss";
@import "CSS/common.scss";
@import "CSS/fonts.scss";

.wb-overlay-screen{
  width: 100%;
  position: absolute;
  background-color: rgba(45, 56, 67, 0.9);
  padding: 16px;
  height: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
.wb-overlay-screen-container{
  width: 740px;
  height: 665px;
  background-color: #FFFFFF;
  padding: 16px 40px 48px 40px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 300;
}
.wb-overlay-screen-close{
  position: absolute;
  top: 16px;
  right: 16px;
}
.wb-overlay-screen-text{
  padding-top: 32px;
  color: #2D3843;
  font-family: Montserrat;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: -0.48px;
}
.wb-overlay-screen-img{
  width: 100%;
  height: 100%;
  padding-bottom: 48px;
  padding-top: 32px;
}
.wb-overlay-screen-button{
  color: var(--white, #FFF);
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: uppercase;
  border-radius: 30px;
  background: var(--primary-2, #60AB9E);
  display: flex;
  height: 40px;
  border: 0;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  align-self: start;
}
</style>
